import styles from "./PriceCard.module.css";
import PropTypes from "prop-types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import ButtonMd from "../../Button/ButtonMd";
import { buildSignupUrlWithMarketingParams } from "../../../utils/signupMarketingUrl";
import { useEffect, useState } from "react";

const PriceCard = ({ amount, payType, planType, planDescription, modelId, price, features, variants = [] }) => {
  const [selectedVariant, setSelectedVariant] = useState(null);

  useEffect(() => {
    if (planType === "Pro" && variants && variants.length > 0) {
      const proStarterVariant = variants.find(v => v.name === "Pro Starters");
      if (proStarterVariant) {
        setSelectedVariant(proStarterVariant);
      } else {
        setSelectedVariant(variants[0]);
      }
    }
  }, [variants, planType]);

  const handleGetStarted = () => {
    if (price === 0) {
      window.open(buildSignupUrlWithMarketingParams(), "_blank", "noopener,noreferrer");

      return;
    }

    if (!modelId || !planType) {
      // eslint-disable-next-line no-console
      console.error("Missing pricing data.");

      return;
    }

    // changed the naming for security purposes
    // pmid = price_model_id
    // dur = duration
    // pname = plan_name
    const pricingExtras =
      planType === "Pro" && selectedVariant
        ? {
          pmid: modelId,
          price: selectedVariant.price,
          pname: planType,
          var_id: selectedVariant.id,
          variant_name: selectedVariant.name
        }
        : {
          pmid: modelId,
          price,
          pname: planType
        };

    const url = buildSignupUrlWithMarketingParams(pricingExtras);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`${styles.pricemain}`}>
      <div className={`${styles.pricecont}`}>
        <div className={styles.priceheading}>
          <h5>{planType}</h5>
          <h6>Starting From:</h6>
          <h3>
            {amount}/{payType}
          </h3>
          <h6></h6>
          <div className={styles.pricedesc}>{planDescription}</div>
        </div>
        <div className={`${styles.subdesc}`}>

          {features?.map((feat, i) => {
            return (
              <div key={i} className={`${styles.featuredesc} flex gap-8 align-item-center`}>
                {feat === "NULL" ? <ClearIcon className="icon-red" /> : <CheckCircleIcon className="light-blue" />}
                <p>{feat === "NULL" ? "--------------------------------------------" : feat}</p>
              </div>
            );
          })}
        </div>
        <ButtonMd title="Get Started" onClick={handleGetStarted} />
      </div>
    </div>
  );
};
PriceCard.PropTypes = {
  amount: PropTypes.string,
  payType: PropTypes.string,
  planType: PropTypes.string,
  planDescription: PropTypes.string,
  price: PropTypes.number,
  modelId: PropTypes.string,
  duration: PropTypes.string
};

export default PriceCard;
